import { render, staticRenderFns } from "./keFuDialogTwo.vue?vue&type=template&id=ca21007a"
import script from "./keFuDialogTwo.vue?vue&type=script&lang=js"
export * from "./keFuDialogTwo.vue?vue&type=script&lang=js"
import style0 from "./keFuDialogTwo.vue?vue&type=style&index=0&id=ca21007a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports